export default function adapter(props) {
  const { context, position, device, mediaType, externalResponse } = props

  const key = `${device}_${context}_${position}_${mediaType}`

  return {
    data: externalResponse?.data[key] || []
  }
}
